import { Box, BoxProps, Center, Flex, Image } from '@chakra-ui/react';
import logoWhiteWithText from 'src/assets/icons/logos/logoWhiteWithText.svg';
import colors from 'src/theme/colors';

function TopBar({ children, ...otherProps }: BoxProps) {
  return (
    <Box
      h={{ sm: '66px', md: '78px' }}
      background={colors.podcastPurple}
      boxShadow={{
        sm: '0px 0px 18px rgba(77, 59, 187, 0.34)',
        md: '0px 0px 24px rgba(77, 59, 187, 0.34)',
        lg: undefined,
        xl: '0px 0px 36px rgba(77, 59, 187, 0.34)',
      }}
      minW="320px"
      position="relative"
      {...otherProps}
    >
      <Center h="100%" px={{ sm: '15px', md: 0 }}>
        <Flex
          justifyContent={children ? 'space-between' : 'space-around'}
          alignItems="center"
          w={{ sm: '100%', md: '510px', lg: '710px', xl: '950px', '2xl': '1140px' }}
          minW="250px"
        >
          <a href="https://alitu.com/" aria-label="Alitu web page">
            <Image
              src={logoWhiteWithText}
              w={{ sm: '120px', md: '140px' }}
              h={{ sm: '36px', md: '42px' }}
              objectFit="contain"
              _hover={{ opacity: 0.9 }}
              _active={{ opacity: 0.8 }}
              alt="Alitu the podcast maker logo"
            />
          </a>
          {children}
        </Flex>
      </Center>
    </Box>
  );
}

export default TopBar;
